<template>
  <transition @after-enter="onAfterEnter" @leave="onLeave">
    <div class="creator-detail-container" v-if="cid > 0" ref="wrapper">
      <animated-gradient-bg
        v-if="$bowser.mobile"
        class="detail__bg-container onShowEffect"
        sign="aboutDetailBg"
      ></animated-gradient-bg>
      <div class="detail__main-container" :class="[innerTheme]">
        <!-- <div class="detail__main__header">
          <page-header></page-header>
        </div> -->
        <div class="detail__main__cover onShowEffect" v-if="$bowser.mobile">
          <img :src="info.src" alt="" />
        </div>
        <div class="detail__close onShowEffect" @click="onClose">
          <div class="line"></div>
          <p>back</p>
        </div>
        <div class="detail__content" v-if="info">
          <el-scrollbar>
            <div class="up-part">
              <div class="content__part -cn">
                <div class="part__name onShowEffect">
                  <p>
                    <strong>{{ info.name.cn }}</strong> | {{ info.job.cn }}
                  </p>
                </div>
                <div class="part__summary onShowEffect">
                  <p>{{ info.summary.cn }}</p>
                </div>
              </div>
              <div class="content__part -en">
                <div class="part__name onShowEffect">
                  <p>
                    <strong>{{ info.name.en }}</strong> | {{ info.job.en }}
                  </p>
                </div>
                <div class="part__summary onShowEffect">
                  <p>{{ info.summary.en }}</p>
                </div>
              </div>
            </div>
            <div class="down-part">
              <div class="content__part -cn">
                <div class="part__awards onShowEffect">
                  <p v-for="(award, index) in info.awards.cn.split('\r\n')" :key="index">
                    {{ award }}
                  </p>
                </div>
              </div>
              <div class="content__part -en">
                <div class="part__awards onShowEffect">
                  <p v-for="(award, index) in info.awards.en.split('\r\n')" :key="index">
                    {{ award }}
                  </p>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import animatedGradientBg from './_animated-gradient-bg.vue';
// import pageHeader from '../common/header.vue';

export default {
  name: 'c__creator-detail',
  components: {
    animatedGradientBg,
    // pageHeader,
  },
  props: {
    theme: {
      type: String,
      default: 'right',
    },
    id: {
      type: Number,
      default: 0,
    },
    info: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      cid: this.id,
      innerTheme: this.theme,
    };
  },
  watch: {
    id: {
      handler(val) {
        this.cid = val;
      },
      immediate: true,
    },
    theme(val) {
      this.innerTheme = val;
    },
  },
  computed: {
    detail() {
      return null;
    },
    screenHeight() {
      return window.innerHeight;
    },
  },
  methods: {
    onAfterEnter(el) {
      const that = this;
      that.$nextTick(() => {
        el.classList.add('on-show');
      });
    },
    onLeave(el, done) {
      el.classList.remove('on-show');
      setTimeout(() => {
        done();
      }, 1000);
    },
    onClose() {
      this.$emit('onClose');
    },
  },
};
</script>

<style></style>
